import { Upload } from "baseui/icon";
import ROUTE_PATH from "./RouteConstants";


const APP_MAIN_NAV_ITEMS = {
  marketplace: "Marketplace",
  templates: "Templates",
  modelers: "Modelers",
};

const APP_NAVE_MENU_ITEMS = [
  // {
  //   label: APP_MAIN_NAV_ITEMS.marketplace,
  //   route: `${ROUTE_PATH.marketplace}`,
  //   active: false,
  // },
  {
    label: APP_MAIN_NAV_ITEMS.templates,
    active: false,
    route: `${ROUTE_PATH.templates}managed`,
  },
  {
    label: APP_MAIN_NAV_ITEMS.modelers,
    route: `${ROUTE_PATH.modelers}managed`,
    active: false,
  },

];
const TREE_ITEM_TYPES = {
  FOLDER: "FOLDER",
  FILE: "FILE",
  OBJECT: "OBJECT",
  ROOT: "ROOT",
  GROUP: "GROUP",
  MULTIOPTION: "MULTIOPTION",
  NUMERIC: "NUMERIC",
  TEXT: "TEXT",
  MULTIRADIO: "MULTORADIO",
};
const ACCESS_TYPES ={
  MANAGED: "MANAGED",
  PRIVATE: "PRIVATE",
  PUBLIC: "PUBLIC",
  PROTECTED: "PROTECTED"
}
const COMPUTE_TYPES = {
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE",
};

const TIME_TYPES = {
  ALL: "ALL",
  WEEK: "WEEK",
  MONTH: "MONTH",
  YEAR: "YEAR",
};
const INPUT_TYPES = {
  NUMBER: "number",
  GROUP: "group",
};
const RESOURCE_TYPES = {
  PRODUCT: "product",
  MODELER: "modeler",
  TEMPLATE: "template",
  MODELRUN: "modelrun"
}
const SOLVER_TYPES = {
  OPENFOAM: "OPENFOAM",
  GERRIS: "GERRIS",
  SU2: "SU2",
}
const MODELRUN_ROW_MENU_ACTIONS = {
  SELECT: 'SELECT',
  DELETE: 'DELETE'
}

const COMTEXT_MENU_ACTIONS = {
  NEWFOLDER: 0,
  NEWFILE: 1,
  NEWOBJECT: 2,
  DELETE: 3,
  RENAME: 4,
};
const TREE_CONTEXT_MENU_FOLDER_ITEMS = [
  { label: "New Folder", action: COMTEXT_MENU_ACTIONS.NEWFOLDER },
  { label: "New Object", action: COMTEXT_MENU_ACTIONS.NEWOBJECT},
  { label: "New File", action: COMTEXT_MENU_ACTIONS.NEWFILE },
  { label: "Delete", action: COMTEXT_MENU_ACTIONS.DELETE },
  { label: "Rename", action: COMTEXT_MENU_ACTIONS.RENAME },
];

const TREE_CONTEXT_MENU_FILE_ITEMS = [
  { label: "Delete", action: COMTEXT_MENU_ACTIONS.DELETE },
  { label: "Rename", action: COMTEXT_MENU_ACTIONS.RENAME },
];
const TREE_CONTEXT_MENU_GROUP_ITEMS = [
  { label: "Delete", action: COMTEXT_MENU_ACTIONS.DELETE },
];
const TREE_CONTEXT_MENU_PARAMETER_ITEMS = [
  { label: "Delete", action: COMTEXT_MENU_ACTIONS.DELETE },
];
const TREE_CONTEXT_MENU_ITEMS = {
  [TREE_ITEM_TYPES.FOLDER]: TREE_CONTEXT_MENU_FOLDER_ITEMS,
  [TREE_ITEM_TYPES.OBJECT]: TREE_CONTEXT_MENU_FILE_ITEMS,
  [TREE_ITEM_TYPES.FILE]: TREE_CONTEXT_MENU_FILE_ITEMS,
  [TREE_ITEM_TYPES.ROOT]: TREE_CONTEXT_MENU_FOLDER_ITEMS,
  [TREE_ITEM_TYPES.GROUP]: TREE_CONTEXT_MENU_GROUP_ITEMS,
  [TREE_ITEM_TYPES.NUMERIC]: TREE_CONTEXT_MENU_PARAMETER_ITEMS,
  [TREE_ITEM_TYPES.MULTIOPTION]: TREE_CONTEXT_MENU_PARAMETER_ITEMS,
  [TREE_ITEM_TYPES.TEXT]: TREE_CONTEXT_MENU_PARAMETER_ITEMS,
};

const MODELRUN_ROW_MENU_ITEMS = [
  {label: "Select", action: MODELRUN_ROW_MENU_ACTIONS.SELECT},
  {label: "Delete", action: MODELRUN_ROW_MENU_ACTIONS.DELETE}
]

const MAIN_SIDEBAR_ITEMS = [
  {
    // name: "home",
    title: "Home",
    // Icon: HomeIcon,
    itemId: ROUTE_PATH.modelerExecuteHome,
    // handleClick: true,
  },
  {
    title: "Executions",
    itemId: ROUTE_PATH.modelerExecuteTasks,
    
  },  
  {
    // name: "history",
    title: "History",
    // Icon: HistoryIcon,
    itemId: ROUTE_PATH.modelerExecuteHistory,
    // handleClick: true,
  },
  {
    // name: "history",
    title: "Attachments",
    // Icon: HistoryIcon,
    itemId: ROUTE_PATH.modelerExecuteGallery,
    // handleClick: true,
  },
  {
    // name: "history",
    title: "Post Processing",
    // Icon: HistoryIcon,
    itemId: ROUTE_PATH.modelerPostProcessing,
    // handleClick: true,
  },
  {
    // name: "reports",
    title: "Reports",
    // Icon: ReportsIcon,
    itemId: ROUTE_PATH.modelerReports,
    // handleClick: true,
  },
  // {
  //   // name: "monitor",
  //   title: "Monitor",
  //   // Icon: DvrOutlinedIcon,
  //   itemId: ROUTE_PATH.modelerExecuteMonitor,
  //   // handleClick: true,
  // },
];

const MODELERS_SIDEBAR_ITEMS = [
  {
    title: "Tutorials",
    itemId: ROUTE_PATH.modelersManaged,
  },  
  {
    title: "Public Modelers",
    itemId: ROUTE_PATH.modelersPublic,
  },
  {
    title: "Private Modelers",
    itemId: ROUTE_PATH.modelersPrivate,
  },

];
const TEMPLATES_SIDEBAR_ITEMS = [
  {
    title: "Tutorials",
    itemId: ROUTE_PATH.templatesManaged
  },  
  {
    title: "Public Templates",
    itemId: ROUTE_PATH.templatesPublic,
  },
  {
    title: "Private Templates",
    itemId: ROUTE_PATH.templatesPrivate,
  },
  // {
  //   // name: "shared-with-me",
  //   title: "Shared with me",
  //   itemId: ROUTE_PATH.templatesShared,
  //   // Icon: DvrOutlinedIcon,
  //   // path: ROUTE_PATH.modelersShared,
  //   // handleClick: true,
  // },
  // {
  //   // name: "my-favorites",
  //   title: "My Favorites",
  //   itemId: ROUTE_PATH.templatesfavorite,
  //   // Icon: DvrOutlinedIcon,
  //   // path: ROUTE_PATH.modelersfavorite,
  //   // handleClick: true,
  // },
];

const ACCOUNT_SIDEBAR_ITEMS = [
  {
    // name: "home",
    title: "Profile",
    // Icon: HomeIcon,
    itemId: ROUTE_PATH.PROFILE,
    // handleClick: true,
  },
  {
    // name: "history",
    title: "Organization",
    // Icon: HistoryIcon,
    itemId: ROUTE_PATH.ORGANIZATION,
    // handleClick: true,
  },
  {
    title: "Charges/Usage",
    itemId: ROUTE_PATH.USAGE,
  },
  {
    title: "Subscription",
    itemId: ROUTE_PATH.BILLING,
  },
  {
    title: "Credits/Deposits",
    itemId: ROUTE_PATH.DEPOSIT
  }

  // {
  //   // name: "history",
  //   title: "Organizations",
  //   // Icon: HistoryIcon,
  //   itemId: ROUTE_PATH.ORGANIZATIONS,
  //   // handleClick: true,
  // },
  // {
  //   // name: "monitor",
  //   title: "Members",
  //   // Icon: DvrOutlinedIcon,
  //   itemId: ROUTE_PATH.MEMBERS,
  //   // handleClick: true,
  // },
];
export {
  TREE_ITEM_TYPES,
  TREE_CONTEXT_MENU_ITEMS,
  COMTEXT_MENU_ACTIONS,
  INPUT_TYPES,
  MAIN_SIDEBAR_ITEMS,
  TEMPLATES_SIDEBAR_ITEMS,
  APP_MAIN_NAV_ITEMS,
  APP_NAVE_MENU_ITEMS,
  MODELERS_SIDEBAR_ITEMS,
  ACCESS_TYPES,
  MODELRUN_ROW_MENU_ITEMS,
  MODELRUN_ROW_MENU_ACTIONS,
  ACCOUNT_SIDEBAR_ITEMS,
  RESOURCE_TYPES,
  TIME_TYPES,
  SOLVER_TYPES,
  COMPUTE_TYPES,
};
